import { BrowserRouter, Route, Routes } from "react-router-dom";
import ScrollToTop from "../helpers";
import Dashboard from "../../views/Dashboard/Dashboard";
import Layout from "../../components/Layout/Layout";
import SignIn from "../../views/SignIn/SignIn";
import ForgotPassword1 from "../../views/ForgotPassword1/ForgotPassword1";
import ForgotPassword2 from "../../views/ForgotPassword2/ForgotPassword2";
import ForgotPassword3 from "../../views/ForgotPassword3/ForgotPassword3";
import Profile from "../../views/Profile/Profile";
import UserDetails from "../../views/UserDetails/UserDetails";
import DriverDetails from "../../views/DriverDetails/DriverDetails";
import CarDetails from "../../views/CarDetails/CarDetails.jsx";
import UserManagement from "../../views/UserManagement/UserManagement";
import AddUser from "../../views/AddUser/AddUser";
// import UserDetails from "../../views/DriverDetails/DriverDetails";
import DriverManagement from "../../views/DriverManagement/DriverManagement";
import ChauffeurRequestList from "../../views/DriverManagement/ChauffeurRequestList";
import ChauffeurUpdateRequest from "../../views/DriverManagement/ChauffeurUpdateRequest";
import ViewNotification from "../../views/ViewNotification/ViewNotification.jsx";
import Notifications from "../../views/Notifications/Notifications";
import DisplayNotification from "../../views/DisplayNotification/DisplayNotification";
import CarManagement from "../../views/CarManagement/CarManagement";
import CarUpdateRequest from "../../views/CarManagement/carUpdateRequest";
import CarUpdatedetails from "../../views/CarManagement/carUpdatedetails";
import NewCarRequest from "../../views/NewCarRequest/NewCarRequest";
import ExistingCarRequest from "../../views/ExistingCarRequest/ExistingCarRequest";
import NewCarApproval from "../../views/NewCarApproval/NewCarApproval";
import ExistingCarApproval from "../../views/ExistingCarApproval/ExistingCarApproval";
import FeedbackManagement from "../../views/FeedbackManagement/FeedbackManagement";
import FeedbackDetail from "../../views/FeedbackDetail/FeedbackDetail";
import PaymentLogs from "../../views/PaymentLogs/PaymentLogs";
import PaymentLogDetails from "../../views/PaymentLogs/paymentLogDetails";
import PaymentLogMember from "../../views/paymentLogMember";
import PaymentLogMemberDetails from "../../views/paymentLogMember/paymentLogMemberDetails";
import ReportManagement from "../../views/ReportManagement/ReportManagement";
import ReportDetails from "../../views/ReportDetails/ReportDetails";
import FareManagement from "../../views/FareManagement/FareManagement";
import RateManagement from "../../views/RateManagement/index.js";
import CompanyRate from "../../views/CompanyRate/index.js";
import RushHourmanagement from "../../views/RushHourmanagement/index.js";
import CommissionManagement from "../../views/CommissionManagement/CommissionManagement";
import UpdateProfile from "../../views/UpdateProfile/UpdateProfile";
import ChangePassword from "../../views/ChangePassword/ChangePassword";
import RecentBooking from "../../views/recentBooking";
import ProtectedRoute from "../../views/protectedRoute";
import { useSelector } from "react-redux";
import socket from "../socket/index";
import Membership from "../../views/Memberships/index.js";
import MembershipDetails from "../../views/Memberships/MembershipDetails.js";
import MembershipPackages from "../../views/MembershipPackages/index.js";
import ViewPackage from "../../views/MembershipPackages/ViewPackage.js";
import EditPackage from "../../views/MembershipPackages/EditPackage.js";
import Messages from "../../views/Messages/index.js";
import MessagesDetails from "../../views/Messages/messagesDetails.js";
import ReservationRequests from "../../views/ReservationRequests/index.js";
import RequestDetails from "../../views/ReservationRequests/RequestDetails.js";
import RegisterChauffeur from "../../views/RegisterChauffeur/index.js";
import { useEffect } from "react";
import BookChauffeur from "../../views/BookChauffeur/index.js";
import Payment from "../../views/Payment/index.js";
import DistanceRate from "../../views/DistanceRate/index.js";
import DistanceFare from "../../views/DistanceFare/index.js";
import DiscountManagement from "../../views/DiscountManagement/index.jsx";
import TermsAndConditions from "../../views/TermsAndConditions/index.jsx";

const MyRouter = () => { 
  const token = useSelector((state) => state.user.userToken);
  const user = useSelector((state) => state.user.userData);
  useEffect(() => {
    if (token) {
      socket.emit("setupAdmin", user);
    }
    // eslint-disable-next-line
  }, []);
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <ScrollToTop />
      <Routes>
        <Route path="/login" element={<SignIn />} />
        <Route path="/forgotPassword" element={<ForgotPassword1 />} />
        <Route path="/forgotPassword/otp" element={<ForgotPassword2 />} />
        <Route
          path="/forgotPassword/changePassword"
          element={<ForgotPassword3 />}
        />

        {/*--------------------------------------------------------------------------------------------*/}

        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout>
                <Dashboard />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Layout>
                <Profile />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/registerChauffeur"
          element={
            <ProtectedRoute>
              <Layout>
                <RegisterChauffeur />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/updateProfile"
          element={
            <ProtectedRoute>
              <Layout>
                <UpdateProfile />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/reservationRequests"
          element={
            <ProtectedRoute>
              <Layout>
                <ReservationRequests />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/reservationRequests/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <RequestDetails />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/changePassword"
          element={
            <ProtectedRoute>
              <Layout>
                <ChangePassword />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/userDetails/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <UserDetails />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/driverDetails/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <DriverDetails />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/userManagement"
          element={
            <ProtectedRoute>
              <Layout>
                <UserManagement />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/addUser"
          element={
            <ProtectedRoute>
              <Layout>
                <AddUser />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/driverManagement"
          element={
            <ProtectedRoute>
              <Layout>
                <DriverManagement />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/ChauffeurRequestList"
          element={
            <ProtectedRoute>
              <Layout>
                <ChauffeurRequestList />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/ChauffeurRequestList/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <ChauffeurUpdateRequest />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/notifications"
          element={
            <ProtectedRoute>
              <Layout>
                <Notifications />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/recentNotifications"
          element={
            <ProtectedRoute>
              <Layout>
                <DisplayNotification />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/viewNotification/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <ViewNotification />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/carManagement"
          element={
            <ProtectedRoute>
              <Layout>
                <CarManagement />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/carDetails/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <CarDetails />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/carUpdateRequest"
          element={
            <ProtectedRoute>
              <Layout>
                <CarUpdateRequest />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/carUpdateRequest/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <CarUpdatedetails />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/carRequest/new"
          element={
            <ProtectedRoute>
              <Layout>
                <NewCarRequest />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/carApproval/new"
          element={
            <ProtectedRoute>
              <Layout>
                <NewCarApproval />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/carRequest/existing"
          element={
            <ProtectedRoute>
              <Layout>
                <ExistingCarRequest />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/carApproval/existing"
          element={
            <ProtectedRoute>
              <Layout>
                <ExistingCarApproval />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/recentBooking"
          element={
            <ProtectedRoute>
              <Layout>
                <RecentBooking />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/memberships"
          element={
            <ProtectedRoute>
              <Layout>
                <Membership />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/membershipDetails/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <MembershipDetails />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/membershipPackages"
          element={
            <ProtectedRoute>
              <Layout>
                <MembershipPackages />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/membershipPackages/view/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <ViewPackage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/membershipPackages/edit/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <EditPackage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/messages"
          element={
            <ProtectedRoute>
              <Layout>
                <Messages />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/messagesDetails/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <MessagesDetails />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/feedbackManagement"
          element={
            <ProtectedRoute>
              <Layout>
                <FeedbackManagement />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/bookingRequestDetails/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <FeedbackDetail />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/feedbackDetails/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <FeedbackDetail />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/paymentLogs"
          element={
            <ProtectedRoute>
              <Layout>
                <PaymentLogs />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/paymentLogDetails"
          element={
            <ProtectedRoute>
              <Layout>
                <PaymentLogDetails />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/paymentLogMember"
          element={
            <ProtectedRoute>
              <Layout>
                <PaymentLogMember />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/paymentLogMemberDetails"
          element={
            <ProtectedRoute>
              <Layout>
                <PaymentLogMemberDetails />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/reportManagement"
          element={
            <ProtectedRoute>
              <Layout>
                <ReportManagement />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/reportDetails/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <ReportDetails />
              </Layout>
            </ProtectedRoute>
          }
        />
    
        <Route
          path="/fareManagement"
          element={
            <ProtectedRoute>
              <Layout>
                <FareManagement />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/distanceFare"
          element={
            <ProtectedRoute>
              <Layout>
                <DistanceFare />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/discountManagement"
          element={
            <ProtectedRoute>
              <Layout>
                <DiscountManagement />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/rateManagement"
          element={
            <ProtectedRoute>
              <Layout>
                <RateManagement />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/distanceRate"
          element={
            <ProtectedRoute>
              <Layout>
                <DistanceRate />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/companyRate"
          element={
            <ProtectedRoute>
              <Layout>
                <CompanyRate />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/rushHourmanagement"
          element={
            <ProtectedRoute>
              <Layout>
                <RushHourmanagement />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/commissionManagement"
          element={
            <ProtectedRoute>
              <Layout>
                <CommissionManagement />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/bookChauffeur"
          element={
            <ProtectedRoute>
              <Layout>
                <BookChauffeur />
              </Layout>
            </ProtectedRoute>
          }
        />
         <Route
          path="/payment"
          element={
            <ProtectedRoute>
              <Layout>
                <Payment />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/termsAndConditions"
          element={
            <ProtectedRoute>
              <Layout>
                <TermsAndConditions />
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default MyRouter;
